import {Component, HostListener, Input, OnDestroy, OnInit} from "@angular/core";
import {EmbedService} from "../../services/embed.service";
import {Subscription} from "rxjs";

/**
 * Infotext that is displayed as fixed content with a transparent background
 */
@Component({
    selector: 'dialog-infotext',
    templateUrl: './infotext.component.html',
    styleUrls: [],
    standalone: false
})
export class InfotextComponent implements OnInit, OnDestroy {

  /**
   * textkey for the hint text
   */
  @Input() textkeyContent: string;

  /**
   * textkey for the button, optional.
   */
  @Input() textkeyButton: string = null;

  /**
   * toggle for the hint text
   */
  showHint: boolean = false;

  /**
   * scrolloffset if embeded
   */
  scrollOffset: number = 0;

  /**
   * list of subscriptions that we unsubscribe on destroy
   */
  subscriptions: Subscription[] = [];

  /**
   * constructor
   * @param embedService
   */
  constructor(private embedService: EmbedService) {}

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // if embedded, set tthe to position absolute
    if(this.embedService.isEmbedded() === true) {
      this.scrollOffset = 100;
      this.subscriptions.push(this.embedService.scrollEvent.subscribe(data => this.scrollOffset = Math.max(100, ((data.offset * -1) + 100))));
    }
  }

  /**
   * @inheritDoc
   */
  ngOnDestroy() {
    // unsubscribe from subscriptions
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  /**
   * Close the hint if the user clicks somewhere on the background
   * @param event
   */
  @HostListener('window:click', ['$event'])
  closeHint(event): void {
    if(this.showHint === true && (event.target.classList.contains('infotext-background') || event.target.classList.contains('close'))) {
      this.showHint = false;
    }
  }


}
